import React from 'react';
import { Box, Typography } from '@mui/material';

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  // Allow passing any other props
  [key: string]: any;
}

const TabPanel: React.FC<TabPanelProps> = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: '100%', overflow: 'auto', backgroundColor: '#F1F2F4', ...(other.style || {}) }}
    >
      {value === index && (
        <Box style={{ height: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanel; 